/**
 * CTR Variant Selector – PDP size / variant cards (CTR)
 *
 * Selecting a card syncs the product form variant ID and, when present,
 * the native variant-selects option inputs so product-info updates prices/media.
 */
(function () {
  if (window.__ctrVariantSelectorInit) return;
  window.__ctrVariantSelectorInit = true;

  function escapeCssIdent(value) {
    if (window.CSS && typeof CSS.escape === 'function') return CSS.escape(String(value));
    return String(value).replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  }

  function parseOptions(card) {
    try {
      var raw = card.getAttribute('data-variant-options');
      if (!raw) return [];
      return JSON.parse(raw);
    } catch (e) {
      return [];
    }
  }

  function setActiveCard(selector, card) {
    selector.querySelectorAll('[data-ctr-variant-card]').forEach(function (el) {
      var active = el === card;
      el.classList.toggle('is-active', active);
      el.setAttribute('aria-pressed', active ? 'true' : 'false');
    });
  }

  function updateFormVariantId(productInfo, variantId) {
    if (!variantId) return;
    var sectionId = productInfo && (productInfo.dataset.section || productInfo.dataset.originalSection);
    var forms = [];

    if (sectionId) {
      var form = document.getElementById('product-form-' + sectionId);
      var installment = document.getElementById('product-form-installment-' + sectionId);
      if (form) forms.push(form);
      if (installment) forms.push(installment);
    }

    if (!forms.length && productInfo) {
      productInfo.querySelectorAll('form[is="product-form"], form[action*="/cart/add"]').forEach(function (f) {
        forms.push(f);
      });
    }

    forms.forEach(function (productForm) {
      var input = productForm.querySelector('input[name="id"]');
      if (!input) return;
      input.value = variantId;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });

    document.querySelectorAll('.product-variant-id').forEach(function (input) {
      if (productInfo && !productInfo.contains(input) && input.closest('product-info') !== productInfo) return;
      input.value = variantId;
    });
  }

  function syncVariantSelects(productInfo, options) {
    if (!productInfo || !options || !options.length) return false;

    var variantSelects = productInfo.querySelector('variant-selects');
    if (!variantSelects) return false;

    var changed = false;

    options.forEach(function (optValue) {
      if (optValue == null || optValue === '') return;

      var radio = variantSelects.querySelector(
        'input[type="radio"][value="' + escapeCssIdent(String(optValue)) + '"]'
      );
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
        return;
      }

      var select = null;
      variantSelects.querySelectorAll('select').forEach(function (s) {
        if (select) return;
        for (var i = 0; i < s.options.length; i++) {
          if (s.options[i].value === String(optValue)) {
            select = s;
            break;
          }
        }
      });

      if (select && select.value !== String(optValue)) {
        select.value = String(optValue);
        select.dispatchEvent(new Event('change', { bubbles: true }));
        changed = true;
      }
    });

    return changed;
  }

  function updateUrl(productUrl, variantId) {
    if (!productUrl || !variantId) return;
    try {
      var url = new URL(productUrl, window.location.origin);
      url.searchParams.set('variant', variantId);
      window.history.replaceState({}, '', url.pathname + url.search);
    } catch (e) {
      // Ignore URL update failures.
    }
  }

  function selectVariant(card) {
    if (!card || card.disabled || card.classList.contains('is-active')) return;

    var selector = card.closest('[data-ctr-variant-selector]');
    if (!selector) return;

    var variantId = card.dataset.variantId;
    var options = parseOptions(card);
    var productInfo = card.closest('product-info');
    var productUrl = (productInfo && productInfo.dataset.url) || selector.dataset.productUrl;

    setActiveCard(selector, card);

    var synced = syncVariantSelects(productInfo, options);
    if (!synced) {
      updateFormVariantId(productInfo, variantId);
      updateUrl(productUrl, variantId);

      document.dispatchEvent(
        new CustomEvent('variant:changed', {
          detail: { variant: { id: Number(variantId) } },
        })
      );

      if (window.FoxTheme && FoxTheme.pubsub && FoxTheme.pubsub.PUB_SUB_EVENTS) {
        FoxTheme.pubsub.publish(FoxTheme.pubsub.PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId: selector.dataset.sectionId,
            variant: { id: Number(variantId) },
          },
        });
      }
    }

    document.dispatchEvent(
      new CustomEvent('ctr:variant-selected', {
        bubbles: true,
        detail: {
          card: card,
          sectionId: selector.dataset.sectionId,
          variantId: Number(variantId),
          available: card.getAttribute('data-variant-available') !== 'false',
          priceCents: Number(card.getAttribute('data-price-cents')) || 0,
          compareAtCents: Number(card.getAttribute('data-compare-at-cents')) || 0,
          sellingPlanId: card.getAttribute('data-selling-plan-id') || '',
          subscribePriceCents: Number(card.getAttribute('data-subscribe-price-cents')) || 0,
        },
      })
    );
  }

  function init() {
    // Click handling is delegated; no per-instance setup required.
  }

  document.addEventListener('click', function (e) {
    var card = e.target.closest('[data-ctr-variant-card]');
    if (!card) return;
    e.preventDefault();
    selectVariant(card);
  });

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('pageshow', init);

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', init);
    document.addEventListener('shopify:section:select', init);
    document.addEventListener('shopify:block:select', init);
  }
})();
